const routes = [
  /*  */
  {
    id: 'home',
    path: '/',
    icon: 'header',
    mobileIcon: 'logo',
  },
  {
    id: 'tournaments',
    name: 'Tournaments',
    path: '/tournaments',
    icon: 'tournaments',
    disabled: true,
  },
  {
    id: 'dashboard',
    name: 'Dashboard',
    path: '/dashboard',
    icon: 'dashboard',
    mobileMain: true,
  },
  {
    id: 'wallet',
    name: 'Wallet',
    path: '/wallet',
    icon: 'wallet',
    mobileMain: true,
  },
  {
    id: 'leadboard',
    name: 'Leadboard',
    path: '/leaderboard',
    icon: 'leadboard',
    mobileMain: true,
  },
  {
    id: 'settings',
    name: 'Settings',
    path: '/settings',
    icon: 'settings',
  },
  {
    id: 'referrals',
    name: 'Referrals',
    path: '/referrals',
    icon: 'referrals',
  },
  /*  */
  {
    id: 'more',
    handler: 'showMore',
    icon: 'ellipsis',
    mobileMain: true,
    mobileOnly: true,
  },
];

export default routes;
